
import { SpeedTestingKey } from '@/utils/i18n/types';

export const speedTesting: Record<SpeedTestingKey, string> = {
  speedTestingManual: "Manual",
  speedTestingAutomatic: "Automático",
  speedTestingActivate: "Ativar",
  speedTestingSave: "Salvar Teste",
  speedTestingMyTests: "Histórico de Testes",
  speedTestingNoData: "Não existem testes de velocidade automáticos",
  speedTestingTooltip: "Como funciona o teste de velocidade?",
  speedTestingTooltipText: "Os testes de velocidade permitem que você faça testes A/B de diferentes velocidades de reprodução para encontrar a configuração ideal para engajamento e conversões.",
  speedTestingVelocity: "Velocidade",
  speedTestingDate: "Data",
  speedTestingViews: "Visualizações",
  speedTestingConversions: "Conversões", 
  speedTestingConversionRate: "Taxa de Conversão",
  speedTestingEngagement: "Engajamento",
  speedTestingPlays: "Plays",
  speedTestingPlayRate: "Play Rate",
  speedTestingClicks: "Cliques",
  speedTestingUniqueViews: "Vis. Únicas",
  speedTestingUniquePlays: "Plays Únicos",
  speedTestingHowToInterpret: "Como interpretar?",
  speedTestingChampionSpeed: "🏆 Velocidade Campeã",
  speedTestingFinalizeTest: "Finalizar Teste",
  speedTestingApply: "Aplicar",
  speedTestingCancel: "Cancelar",
  speedTestingFilterByDate: "Filtrar por período",
  speedTestingLastSevenDays: "7 dias",
  speedTestingLastThirtyDays: "30 dias",
  speedTestingLastNinetyDays: "90 dias",
  speedTestingSelectDateRange: "Selecione um período",
  speedTestingInfoModal: "Como interpretar os testes de velocidade",
  speedTestingInfoModalDesc: "Os testes de velocidade permitem comparar diferentes configurações para encontrar a melhor para seu público.",
  speedTestingMetricsExplanation: "Explicação das métricas",
  speedTestingTipsTitle: "Dicas para testes ideais",
  speedTestingWarningsTitle: "Alertas importantes",
  speedTestingEngagementExplanation: "Medida de quanto tempo os usuários assistem ao vídeo em relação à duração total.",
  speedTestingPlayRateExplanation: "Porcentagem de visualizadores que iniciam a reprodução do vídeo.",
  speedTestingClicksExplanation: "Número de cliques nos elementos interativos do vídeo.",
  speedTestingManualConfig: "Configuração Manual",
  speedTestingAutomaticTest: "Teste Automático",
  speedTestingMetrics: "Métricas do Teste",
  speedTestingEnableCustomSpeed: "Ativar velocidade personalizada",
  speedTestingSpeedMultiplier: "Multiplicador de Velocidade",
  speedTestingEnableSpeedTest: "Ativar teste de velocidade",
  speedTestingInitialSpeed: "Início",
  speedTestingFinalSpeed: "Final",
  speedTestingMinDuration: "Duração mínima do teste",
  speedTestingVictoryCriteria: "Critério de vitória",
  speedTestingKeepCurrentEmbed: "Manter velocidade campeã após finalização",
  speedTestingApplyWinner: "Copiar Código",
  speedTestingRealTimeUpdate: "Atualização em tempo real",
  speedTestingOptionalChart: "Gráfico opcional",
  speedTestingTestDuration: "Duração do teste",
  speedTestingVictoryCriteriaPlayRate: "Play Rate",
  speedTestingVictoryCriteriaClicks: "Cliques no Botão",
  speedTestingVictoryCriteriaViews: "Visualizações",
  speedTestingVictoryCriteriaEngagement: "Engajamento",
  speedTestingVictoryCriteriaConversions: "Conversões",
  speedTestingDays: "dias de teste",
  
  // Novas chaves do PRD
  speedHeaderTitle: "Velocidade de Reprodução",
  speedHeaderSubtitle: "Configure manualmente ou execute testes A/B automáticos para otimizar o engajamento.",
  speedManualSectionTitle: "Configuração de Velocidade Manual",
  speedManualDesc: "Escolha manualmente a velocidade desejada para o seu vídeo. Ideal para testes diretos e controle total sobre a reprodução.",
  speedManualEnableTooltip: "Desabilitado enquanto o Teste Automático estiver ativo.",
  speedManualSliderLabel: "Selecione a velocidade desejada do seu vídeo",
  speedPreviewTitle: "Prévia em Tempo Real",
  speedPreviewCurrent: "Velocidade atual:",
  speedPreviewNote: "Velocidade normal de reprodução.",
  speedAutoSectionTitle: "Teste Automático com Múltiplas Velocidades",
  speedAutoDesc: "Configure testes A/B automáticos com diferentes velocidades para otimizar o engajamento do seu público.",
  speedAutoEnable: "Ativar teste automático com múltiplas velocidades",
  speedAutoInitial: "Velocidade inicial",
  speedAutoFinal: "Velocidade final",
  speedAutoDuration: "Duração mínima do teste",
  speedAutoDurationDays: "dias de teste",
  speedAutoRange: "Intervalo de velocidades",
  speedAutoStatus: "Status",
  speedAutoStatusRunning: "Em execução",
  speedAutoStatusPaused: "Pausado",
  speedAutoStatusDone: "Concluído",
  speedAutoFinish: "Finalizar Teste",
  speedMetricsSubtabMetrics: "Métricas",
  speedMetricsSubtabRetention: "Retenção",
  speedMetricsTip: "Dica: Configure um teste na aba 'Automático' para visualizar métricas comparativas por velocidade.",
  speedMetricsTraffic: "Tráfego",
  speedMetricsViews: "Visualizações",
  speedMetricsUniqueViews: "Vis. Únicas",
  speedMetricsPlays: "Plays",
  speedMetricsUniquePlays: "Plays Únicos",
  speedMetricsPlayrate: "Playrate",
  speedMetricsEngagement: "Engajamento",
  speedMetricsPitch: "Pitch",
  speedMetricsClicks: "Cliques",
  speedMetricsConversions: "Conversões",
  speedMetricsConversionRate: "Conversão",
  speedMetricsRevenue: "Receita"
};
